<script lang="ts" setup>
defineProps<{
  label: string;
}>();

const emits = defineEmits<{
  skipCardSelection: [];
}>();
</script>

<template>
  <footer class="configurator-pick-a-card-footer">
    <button class="configurator-pick-a-card-footer__button" type="button" @click.prevent="emits('skipCardSelection')">
      {{ label }}
    </button>
  </footer>
</template>
